
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.2 18c-23.8 6.3-41.5 23.9-48.1 48-1.9 6.7-2.1 10.3-2.1 33.9 0 29.5.7 34.1 6.6 46.6 8.6 18 23.9 30.4 44 35.5 6.9 1.8 11.1 2 37.8 2 34.2 0 37.8-.5 51.5-7.2 11-5.2 22.8-16.7 28.4-27.5 6.4-12.2 7.9-19.9 8.4-43.4.6-23-.5-34.5-4.2-45.2-6.7-19.5-21.7-34.3-41.6-41.3l-8.4-2.9-32.5-.2c-29.4-.2-33.2-.1-39.8 1.7zM137 68.5V78h-26.3c-19.1 0-26.6.3-27.5 1.2-.7.7-1.2 4-1.2 7.9 0 9.6.6 9.9 18.2 9.9H114v18H98c-17.9 0-21-.7-26.8-6.3-6.2-5.9-7.7-10-7.7-21.2 0-8.8.3-10.7 2.5-14.9 1.4-2.7 4.1-6.2 6.1-7.8 6.6-5.3 9-5.7 38.2-5.8H137v9.5zM80 124c1.5 1.5 2 3.3 2 7.2 0 7.1-1.7 8.8-9.1 8.8-5 0-6-.3-7.8-2.6-3-3.8-2.8-9.8.4-12.9 3.2-3.3 11.4-3.6 14.5-.5z","fill":"#6026ce"}})])
          )
        }
      }
    